module.exports = __webpack_public_path__ + "img/member-2.61799cd0.png";